import { useQuery } from '@tanstack/react-query';

import type { LensProposal } from '~/pages/LeLens/lensProposal';

import { requestWithTimeout } from '~/utils/requestWithTimeout';
import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

type LensCandidateInspection =
  | (Omit<LensProposal, 'status'> & {
      status: 'current';
      overridden?: Array<string>;
      appliedVersion?: number;
    })
  | { status: 'conflict' | 'expired'; candidateId: string; message: string };

export function useLensCandidate(lensId: string, candidateId: string) {
  return useQuery({
    queryKey: ['lens-candidate', lensId, candidateId],
    retry: false,
    queryFn: () =>
      requestWithTimeout<LensCandidateInspection>(
        resolveReportingLeLensUrl(`/api/reporting/le-lenses/${lensId}/changes`),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'inspect', candidateId }),
        },
        'Could not load this candidate',
        30_000,
      ),
  });
}
